import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const LinearIntegration = React.lazy(() => import("./LinearIntegration"));

interface LinearIntegrationLazyProps {
  isOpen: boolean;
  onClose: () => void;
  onRefetch?: () => void;
  brandTheme?: string | null;
}

export default function LinearIntegrationLazy(props: LinearIntegrationLazyProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <LinearIntegration {...props} />
    </Suspense>
  );
}
